import { useTranslation } from 'react-i18next';

export default function B2CSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-foreground-950 py-20 md:py-28">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 md:px-6 lg:grid-cols-2 lg:gap-16">
        <div className="reveal order-2 lg:order-1">
          <span className="mb-5 inline-block h-px w-12 bg-primary-500"></span>
          <h2 className="font-heading text-3xl leading-tight text-background-50 md:text-4xl lg:text-5xl">
            {t('s6.title')}
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-background-100/75 md:text-lg">
            {t('s6.text')}
          </p>
          <a
            href="#iletisim"
            className="mt-8 inline-block whitespace-nowrap rounded-md bg-primary-500 px-8 py-3.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-400"
          >
            {t('s6.cta')}
          </a>
        </div>

        <div className="reveal reveal-delay-1 order-1 lg:order-2">
          <div className="img-hover-zoom overflow-hidden rounded-lg border border-foreground-700/50">
            <img
              src="https://readdy.ai/api/search-image?query=Luxury%20sports%20car%20in%20a%20premium%20minimalist%20setting%20with%20anthracite%20dark%20background%20and%20warm%20gold%20accent%20lighting%2C%20moody%20dramatic%20lighting%2C%20luxury%20automotive%20editorial%20photography%2C%20high%20detail%2C%20reflective%20surfaces%2C%20professional%20photography&width=1200&height=800&seq=vg-car-01&orientation=landscape"
              alt={t('s6.title')}
              title={t('s6.title')}
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}